"use client";

import Link from "next/link";
import { useState } from "react";
import { Cookie, ShieldCheck, Gavel } from "lucide-react";

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { CookieConsent } from "@/components/cookie-consent";

export default function Footer() {
  const [isCookieModalOpen, setIsCookieModalOpen] = useState(false);

  return (
    <footer className="bg-blue-50 border-t-[3px] border-blue-300">
      <div className="container mx-auto py-6 text-sm text-gray-800 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 border-t border-white">
        <div className="text-center md:text-left">
          <b>&copy;</b> {new Date().getFullYear()} Telephony Voice AI Agent<b>™ based on Co:Here technologies</b>
        </div>
        <div className="flex items-center space-x-4">
          <Link href="/legal/privacy-policy" className="hover:text-primary flex items-center space-x-1">
            <ShieldCheck size={16} />
            <span>Privacy Policy</span>
          </Link>
          <Link href="/legal/terms-of-use" className="hover:text-primary flex items-center space-x-1">
            <Gavel size={16} />
            <span>Terms of Use</span>
          </Link>
          <Dialog open={isCookieModalOpen} onOpenChange={setIsCookieModalOpen}>
            <DialogTrigger asChild>
              <button className="hover:text-primary cursor-pointer flex items-center space-x-1">
                <Cookie size={16} />
                <span>Manage Cookies</span>
              </button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-[600px]">
              <DialogHeader>
                <DialogTitle className="text-2xl font-bold">Cookie Consent Preferences</DialogTitle>
              </DialogHeader>
              <CookieConsent onSave={() => setIsCookieModalOpen(false)} />
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </footer>
  );
}
